const initials = "categories/";
export const UPDATE_CATEGORY_REDUCER = `${initials}UPDATE_CATEGORY_REDUCER`;
